import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import googleicon from "../header/images/googleicon.png";
import linkedinicon from "../imagesHome/share-linkedin.png";
import "./sociallogin.css";

const apiUrl = process.env.REACT_APP_API_URL;
const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const SocialLogin = ({ allowDirectSignup = false }) => {
  const sourceQuery = allowDirectSignup ? '&source=login-page' : '';
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;

  const handleGoogleLogin = () => {
    window.location.href = `${apiUrl}/auth/google?flow=login${sourceQuery}`;
  };

  const handleLinkedInLogin = () => {
    window.location.href = `${apiUrl}/auth/linkedin?flow=login${sourceQuery}`;
  };

  // 👉 Login One Tap
  const handleCredentialResponse = (response) => {
    fetch(`${apiUrl}/google-onetap-login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ token: response.credential }),
    })
   .then(async (res) => {
  const data = await res.json();

  if (
    res.ok &&
    data.message === "Autentificat cu succes"
  ) {
    navigateRef.current(
      "/redirecting",
      { replace: true }
    );

    return;
  }

  if (
    res.status === 404 &&
    data.code === "USER_NOT_FOUND"
  ) {
    navigateRef.current(
      "/onboarding-intro",
      { replace: true }
    );

    return;
  }

  const message =
    data?.message ||
    "Autentificarea cu Google a esuat.";

  navigateRef.current(
    `/login?error=${encodeURIComponent(message)}`,
    { replace: true }
  );
})
      .catch((err) => {
        console.error("Eroare One Tap:", err);
        navigateRef.current(`/login?error=${encodeURIComponent("Autentificarea cu Google a eșuat.")}`, { replace: true });
      });
  };

  useEffect(() => {
    if (window.google && clientId) {
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: handleCredentialResponse,
      });

      window.google.accounts.id.prompt();
    }
  }, []);

  return (
    <div className="options-connect">
      {/* Google login clasic */}
      <div className="connect-social google" onClick={handleGoogleLogin}>
        <img src={googleicon} alt="google icon" />
        <span>Conectare cu Google</span>
      </div>

      {/* LinkedIn */}
      <div className="connect-social linkedin" onClick={handleLinkedInLogin}>
        <img src={linkedinicon} alt="linkedin icon" />
        <span>Conectare cu LinkedIn</span>
      </div>

      {/* Email */}
      <div
        className="connect-social email"
        onClick={() => navigate("/emailconnect")}
      >
        <FontAwesomeIcon icon={faEnvelope} />
        <span className="email-color">Conectare cu email</span>
      </div>
    </div>
  );
};

export default SocialLogin;
